
export const BASEURLS = (path) => {
    return `http://localhost/satkartarcrmapi/assets/subadmin/${path}`;
}